import React, { useEffect, useState } from "react";
import {
  Container,
  ContainerNavBar,
  FraseHome,
  Header,
  WrapperHome
} from "./styleHome";
import { NavBar } from "./navBar";
import { IconeHome } from "./IconeHome";
import { Apresentacao } from "../Apresentacao/IndexApresentacao";
import { Editais } from "../Editais/indexEditais";
import { Monitoramento } from "../Monitoramento/indexMonitoramento";
import { Disputa } from "../Disputa/indexDisputa";
import { Contato } from "../Contato/indexContato";
import {Proposta} from "../Proposta/IndexProposta";
import {Licitacao} from "../Licitacoes/indexLicitacao";
import {ModalAviso} from "../Modal/indexModal";

export const IndexHome = () => {
  const [scroll, setScroll] = useState(window.scrollY);
  const [empresas, setEmpresas] = useState(false);
  const [editais, setEditais] = useState(false);
  const [proposta, setProposta] = useState(false);
  const [monitoramento, setMont] = useState(false);
  const [disputa, setDisputa] = useState(false);
  const [licitacao, setLicitacao] = useState(false);
  const [banner, setBanner] = useState(true);

  useEffect(() => {
    window.addEventListener("scroll", () => setScroll(window.scrollY));
    return () => {
      window.removeEventListener("event", () => setScroll(window.scrollY));
    };
  }, []);

  useEffect(() => {
    setScroll(window.scrollY);
    console.log("window.scrollY", window.scrollY);
    if (window.scrollY > 400) {
      setEmpresas(true);
    }
    if (window.scrollY > 1300) {
      setEditais(true);
    }
    if (window.scrollY > 2200) {
      setProposta(true);
    }
    if (window.scrollY > 3100) {
      setLicitacao(true);
    }
    if (window.scrollY > 4000) {
      setMont(true);
    }
    if (window.scrollY > 4900) {
      setDisputa(true);
    }
  }, [window.scrollY]);

  const toogleBanner = () => {
    setBanner(!banner)
  }

  return (
    <>
      <Container background={"#10305D"} id={"home"}>
        {banner &&  <ModalAviso toogleBanner={toogleBanner} />}


        <Header>
          <ContainerNavBar status={scroll} />
          <NavBar />
          <WrapperHome>
            <FraseHome>
              <div>
                <b>
                  AS SOLUÇÕES MAIS <br />
                  PODEROSAS DO MERCADO
                </b>
              </div>
              <p>
                Especializados em pregões eletrônicos, desenvolvemos
                <br /> soluções para que sua empresa armazene e gerencie <br />
                suas licitações com muito mais facilidade.
              </p>
            </FraseHome>
            <IconeHome />
          </WrapperHome>
        </Header>
      </Container>

      <Apresentacao empresas={empresas} />
      <Editais editais={editais} />
      <Proposta proposta={proposta}/>
      <Licitacao licitacao={licitacao}/>
      <Monitoramento monitoramento={monitoramento} />
      <Disputa disputa={disputa} />
      <Contato />
    </>
  );
};
